// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const ESTQ_RESERVA_ORIGEM = {
  PedidoVenda: 'ESTQ_RESERVA_ORIGEM1',
  ConsumoInterno: 'ESTQ_RESERVA_ORIGEM2',
  Producao: 'ESTQ_RESERVA_ORIGEM3',
  Transferencia: 'ESTQ_RESERVA_ORIGEM4',
  PromessaComercial: 'ESTQ_RESERVA_ORIGEM5',
  Manual: 'ESTQ_RESERVA_ORIGEM6',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    ESTQ_RESERVA_ORIGEM1: 1,
    ESTQ_RESERVA_ORIGEM2: 2,
    ESTQ_RESERVA_ORIGEM3: 3,
    ESTQ_RESERVA_ORIGEM4: 4,
    ESTQ_RESERVA_ORIGEM5: 5,
    ESTQ_RESERVA_ORIGEM6: 6
  }
}
